import { FontIcons } from '@brandfolder/react';
import classNames from 'classnames';
import React, { FunctionComponent } from 'react';

import { I18nProviderWrapper } from '@components/common/I18nProviderWrapper';
import { DialogProvider } from '@components/common/providers/DialogContextProvider';

import './usage_info_card.scss';
import UsageInfoCardContent from './UsageInfoCardContent';

export interface Usage {
  current?: number;
  limit?: number | string;
  invites?: number;
}

export interface InfoCard {
  editEnabled?: boolean;
  icon: FontIcons | string;
  title: string;
  usage: Usage;
  customClass?: string;
  dangerAlert?: string;
  hasSetLimits?: boolean;
  isEnabled?: boolean;
  link?: { name: string; linkTo: string };
  orgKey?: string;
  openEditDialog?: () => void;
  setLimitsAction?: () => void;
  setLimitsEnabled?: boolean;
  subtitle?: string;
  warningAlert?: string;
  newRoleTooltip?: {
    open: boolean;
    onClose: () => void;
    maxTotal?: number;
  };
  editCapabilitiesTooltip?: {
    open: boolean;
    onClose: () => void;
    message?: string;
  };
}

const UsageInfoCard: FunctionComponent<InfoCard> = (card) => {
  const { title, customClass, isEnabled } = card;
  const cardWrapperClasses = classNames({
    usageInfoCard: true,
    isDisabled: !isEnabled,
    [customClass]: customClass
  });

  return (
    <I18nProviderWrapper>
      <DialogProvider>
        <div key={title} className={cardWrapperClasses}>
          <UsageInfoCardContent {...card} />
        </div>
      </DialogProvider>
    </I18nProviderWrapper>
  );
};

export default UsageInfoCard;
